const generateSliderStyles = require('./generate-slider-styles.js')

const rooster = {
  handleContainer: {
    position: 'absolute',
    height: '100%',
    left: '156px',
    width: '860px',
  },
}

const tops = {
  handleContainer: {
    position: 'absolute',
    height: '100%',
    width: '860px',
    // left: '157px'
    right: '-20px',
  },
}

const pillWidth = '160px'

module.exports = process.env.REACT_APP_IS_TOPS ?
  generateSliderStyles(tops, { timeLabelColor: '#555555', isTops: true, pillWidth }) :
  generateSliderStyles(rooster, { timeLabelColor: '#8f8f8f', pillWidth })



// WEBPACK FOOTER //
// ./src/components/Settings/styles/Sliders/MissedAppointment.js